/**
 * Mail catcher: a Mailpit-like local SMTP inbox for testing an app's outgoing
 * email while developing (.ai/tasks/2026-09-07_mail_catcher). HOST-RENDERED
 * (components/mailCatcher/MailCatcherView.js) over the Rust `mail_catcher_*`
 * commands — the SMTP listener and its SQLite store live in Rust, the page
 * is a browser over them. The guest entry.js is a no-op kept only to satisfy
 * the registration contract (the FTP/Terminal shape).
 *
 * Rail slot: right after Terminal (a dev tool like Terminal/DB). The tail
 * (Boards/Documents/Vault) and the foot (Chat/Calendar) are owned by
 * ActivityBar.js and stay untouched.
 */
export const mailCatcherManifest = {
  schemaVersion: 1,
  id: 'com.apiboo.mail-catcher',
  name: 'Mail',
  version: '0.1.0',
  publisher: 'apiboo',
  entry: 'dist/main.js',
  icon: 'mail',
  engines: { apibooSdk: '^1.0.0' },
  // HOST-RENDERED, not sandboxed: `permissions: []` means "declares no GUEST
  // capabilities", not "has no access" — see EXT-05 / the FTP manifest.
  hostRendered: true,
  permissions: [],
  contributes: {
    activityBar: [
      {
        id: 'mail-catcher.activity',
        title: 'Mail catcher',
        icon: 'mail',
        order: { after: 'terminal.activity' },
      },
    ],
    panels: [{ id: 'mail-catcher.panel', activityBarId: 'mail-catcher.activity', title: 'Mail catcher' }],
    settings: [],
  },
};
